module.exports = __webpack_public_path__ + "img/GrayDoubleArrowRight.2e864468.svg";